// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const discussionSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  entityType: z.string().max(50),
  entityId: z.string().max(100),
  content: z.string().max(100000),
  contentHtml: z.string().max(200).optional(),
  parentId: z.string().max(100).optional(),
  threadDepth: z.number().int(),
  isEdited: z.boolean(),
  editedAt: z.string().max(200).datetime().optional(),
  isDeleted: z.boolean(),
  deletedAt: z.string().max(200).datetime().optional(),
  userName: z.string().max(200),
  userAvatar: z.string().max(200).optional(),
  attachments: z.array(z.object({
  id: z.string(),
  name: z.string(),
  size: z.number(),
  type: z.string(),
  url: z.string(),
  uploadedAt: z.string().datetime(),
  status: z.string(),
  thumbnailUrl: z.string().optional(),
  checksum: z.string().optional(),
})).optional(),
  reactionCounts: z.record(z.string(), z.unknown()).optional(),
  mentions: z.array(z.object({
  type: z.string().max(50),
  identifier: z.string().max(200),
  teamMemberId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  position: z.number().int().min(0).max(999999),
})).optional(),
  tenantId: z.string().max(100).optional(),
})

export type DiscussionInput = z.infer<typeof discussionSchema>
